import { render, staticRenderFns } from "./proStatusUser.vue?vue&type=template&id=3873965e&scoped=true&"
import script from "./proStatusUser.vue?vue&type=script&lang=js&"
export * from "./proStatusUser.vue?vue&type=script&lang=js&"
import style0 from "./proStatusUser.vue?vue&type=style&index=0&id=3873965e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3873965e",
  null
  
)

export default component.exports